import React from 'react';

import { useRouter } from 'next/router';
import styled from 'styled-components';

import FableticsModal from '~/shared/components/FableticsModal';
import { Button, Heading } from '~/techstyle-shared/react-components';
import {
  defineMessages,
  FormattedMessage,
  useIntl,
} from '~/techstyle-shared/react-intl';

const ProductNotFoundText = styled.p`
  margin-top: 16px;
`;

const ProductNotFoundButton = styled(Button)`
  margin-top: 32px;
  width: auto;
  padding-left: 45px;
  padding-right: 45px;
`;

const defaults = defineMessages({
  productNotFoundModalTitle: {
    id: 'site_pdp.product_not_found_title',
    defaultMessage: "We're Sorry",
  },
});

function ProductNotFoundModal() {
  const router = useRouter();
  const intl = useIntl();

  return (
    <FableticsModal
      defaultOpen
      closeButton={null}
      overlayClickExits={false}
      escapeExits={false}
      title={intl.formatMessage(defaults.productNotFoundModalTitle)}
    >
      <div>
        <Heading level={2}>
          <FormattedMessage
            id="site_pdp.product_not_found_title"
            defaultMessage="We're Sorry"
          />
        </Heading>
        <ProductNotFoundText>
          <FormattedMessage
            id="site_pdp.product_not_found_message_1"
            defaultMessage="There was an error loading this product. We're working to resolve it as quickly as possible."
          />
        </ProductNotFoundText>
        <ProductNotFoundText>
          <FormattedMessage
            id="site_pdp.product_not_found_message_2"
            defaultMessage="Please check back later."
          />
        </ProductNotFoundText>
        <ProductNotFoundButton onClick={router.back} variant="secondary">
          <FormattedMessage
            id="site_pdp.ctl_modal_button_cancel"
            defaultMessage="Go back"
          />
        </ProductNotFoundButton>
      </div>
    </FableticsModal>
  );
}

export default ProductNotFoundModal;
